import styled from "@emotion/styled";
import { colors } from "ui";

const Wrapper = styled.div`
  h1 {
    text-align: center;
    color: ${colors.blackText};
  }

  ol {
    list-style: none;
    counter-reset: cupcake;
    padding-left: 32px;
    margin-top: 20px;
  }
  ol li {
    margin-top: 20px;
    counter-increment: cupcake;
  }
  ol li:before {
    content: counters(cupcake, ".") ". ";
  }
`;

const Terms = () => {
  return (
    <Wrapper>
      <h1>TERMS OF USE</h1>
      <p>
        These following terms (“Terms of Use”) apply to customer’s (“Customer”,
        or “you”) access to and use of all applications and/or websites as well
        as any other media form, media channel, mobile website, software,
        hardware, or mobile application related, linked, or otherwise connected
        thereto (“Services”) provided by Sublyfe AB, org. no. 559315-5285,
        (“Sublyfe”). Sublyfe and Customer are individually named “party” and
        collectively named “parties”.
        <br />
        <br />
        These Terms of Use shall act as a legally binding agreement between the
        parties, and by using the Services, you acknowledge that you have read
        and understood these Terms of Use and agree to be bound by the terms and
        conditions set out below.
      </p>
      <ol>
        <li>
          <strong>ACCEPTANCE OF TERMS</strong>
          <ol>
            <li>
              By registering for and/or using the Services in any manner,
              including but not limited to visiting or browsing Sublyfe’s
              website, you agree to these Terms of Use (including, for clarity,
              the Privacy Policy) and all other policies and procedures that may
              be published from time to time on the Sublyfe website, each of
              which is incorporated by reference and each of which may be
              updated from time to time without notice to you.
            </li>
            <li>
              Certain of the Services may be subject to additional terms and
              conditions specified by Sublyfe from time to time; your use of
              such Services is subject to those additional terms and conditions,
              which are incorporated into these Terms of Use by this reference.
            </li>
            <li>
              These Terms of Use apply to all Customers of the Services,
              including, without limitation, users who are contributors of
              content, information, and other materials or services, registered
              or otherwise.
            </li>
            <li>
              Your use of the Services is regulated by these Terms of Use, and
              you understand and agree that compliance with them is a
              prerequisite for your right to use the Services. You may only
              accept these Terms of Use if you have legal authority to do so. If
              you enter into these Terms of Use on behalf of a legal entity you
              must be authorized to enter into binding agreements on behalf of
              the legal entity concerned under applicable law.
            </li>
          </ol>
        </li>
        <li>
          <strong>PAYMENT</strong>
          <ol>
            <li>
              These terms and conditions (“Terms“) apply to your use of the
              payment solution provided by Sublyfe (“Sublyfe“, “we“, “us“,
              “our“), which enables businesses (“Businesses“) in various
              industries to offer their products and services to their customers
              on a recurring subscription basis (“Services“). By using our
              Services, you agree to be bound by these Terms. If you do not
              agree to these Terms, you may not use our Services.
            </li>
            <li>
              Sublyfe offers Services where Customer is given the possibility to
              use the Services for a recurring fee. The offer entitles you to
              use the Services provided that Sublyfe is given an unrestricted
              right to advertise, independently or through a third-party
              provider, its own or third-parties’ products and services, however
              always subject to applicable laws and regulations.
            </li>
            <li>
              Subscription Terms. The Service is offered on a subscription
              basis. Users may select a subscription term of either six (6)
              months or twelve (12) months, during which time there is no option
              for termination of the subscription. The fee for the subscription
              is based on the length of the subscription term selected by the
              User.
            </li>
            <li>
              By signing up for a Paid Subscription the Customer acknowledges
              that the Customer’s subscription will result in a recurring
              payment by the Customer indefinitely until the subscription period
              has expired six (6) months or twelve (12) months. The Customer
              accepts all responsibility for the recurring charges before
              cancellation by the Customer and is responsible for there being
              sufficient balance on the payment card provided.
            </li>
            <li>
              The currencies available for the Services can be found here:{" "}
              <a href="https://stripe.com/docs/currencies?presentment-currency=SE">
                https://stripe.com/docs/currencies?presentment-currency=SE
              </a>
              . The current fee structure (which may be updated by Sublyfe from
              time to time) is set forth on Sublyfe’s website and/or
              application: Sublyfe retains the right to increase the prices for
              individual Customer and to make other general price adjustments or
              amend the payment methods referred to in these Terms of Use in its
              absolute discretion. Such changes shall be published on Sublyfe’s
              website in due time before they take effect.
            </li>
            <li>
              Unless otherwise stipulated on Sublyfe’s website, Customer’s
              payments to Sublyfe for use of the Services shall be made by one
              of the payment methods set out here (which may be amended to time
              to time): Stripe (“Third-Party Financial Company”. The terms and
              conditions of Sublyfe’s current Third-Party Financial Company
              (Stripe) can be accessed here:{" "}
              <a href="https://stripe.com/en-se/ssa">
                https://stripe.com/en-se/ssa
              </a>
              . Sublyfe shall not be responsible for error by the third-party
              processor. In the event Sublyfe stipulates direct billing, instead
              of the use of Stripe, the Customer shall pay in accordance with
              instructions from Sublyfe.
            </li>
            <li>
              Customer agrees that if Sublyfe, through the Third-Party Financial
              Company or otherwise, does not receive payment from Customer,
              Customer agrees to pay all amounts due upon demand. Any late
              payment shall accrue interest according to the Swedish Interest
              Act (1975:635). In the event of non-payment by Customer, Sublyfe
              retains the right to inactivate Customer’s account and stop
              providing the Services. Sublyfe also reserves the right to refuse
              any order placed through its website and/or application.
            </li>
            <li>
              Customer acknowledges and agrees that if the purchase is subject
              to recurring charges, then the charging of the payment method
              shall be done on a recurring basis without requiring Customer’s
              prior approval for each recurring charge. Customer has the right
              to notify Sublyfe of cancellation, however, is required to pay the
              remaining balance of the subscription period.
            </li>
            <li>
              Sublyfe reserves the right to correct any errors or mistakes in
              pricing, even for requested or received payment.
            </li>
            <li>
              Customer agrees that any information regarding credit cards or
              other payment instruments may be shared by credit agencies,
              Third-Party Financial Companies and other companies involved in
              the payment process related to these Terms of Use and that Sublyfe
              has the right to provide any information if Sublyfe should be
              required by law to provide such information.
            </li>
          </ol>
        </li>
        <li>
          <strong>CONSUMER RIGHTS</strong>
          <ol>
            <li>
              In the event Customer is a consumer (hereinafter “consumer”), all
              mandatory applicable laws and regulations shall apply to the
              consumer. Any consumer in Sweden and a natural person who, in
              relation to activities covered by these Terms of Use, is acting
              for purposes other than trade, business, craft or profession shall
              have a period of fourteen (14) days, to withdraw from the Terms of
              Use without giving any reason (“Withdrawal period” or in Swedish;
              “ångerrättsperiod”). The Withdrawal period shall expire after
              fourteen (14) days from the day of the conclusion of these Terms
              of Use.
            </li>
            <li>
              If the consumer has begun using the Services, the consumer thereby
              accepts that the right of withdrawal according to paragraph 3.1 is
              waived. Notwithstanding this, the consumer still has the
              opportunity to terminate the Services in accordance with paragraph
              10 below. The right of withdrawal applies when the consumer and
              Digito are entering into these Terms of Use at a distance in
              accordance with The Distance and Off-Premises Contracts Act
              (2005:59) (in Swedish; “lagen om distansavtal utanför
              affärslokaler”).
            </li>
            <li>
              If the consumer withdraws from these Terms of Use in accordance
              with this paragraph 3, the consumer shall inform Digito of its
              decision to withdraw from the Terms of Use. In the event a
              consumer in Sweden wishes to use its withdrawal right in
              accordance with this paragraph 3, the consumer can complete the
              forms attached here
              (https://publikationer.konsumentverket.se/kontrakt-och-mallar/angerblankett)
              which originate from Konsumentverket (www.konsumentverket.se; in
              Swedish; “Ångerblankett”).
            </li>
            <li>
              If the consumer withdraws from these Terms of Use in accordance
              with this paragraph 3, Digito shall reimburse the consumer
              applicable payments received from the consumer. The consumer is
              not entitled to any reimbursement if the consumer has accessed the
              Services during the Withdrawal period.
            </li>
          </ol>
        </li>
        <li>
          <strong>DATA PROTECTION</strong>
          <ol>
            <li>
              Customer’s personal data shall be treated in accordance with
              Sublyfe’s Privacy Policy, available at
              [https://sublyfe.com/privacy] and shall be subject to Regulation
              (EU) 2016/679 of the European Parliament and of the Council of 27
              April 2016, General Data Protection Regulation (”GDPR”). For the
              avoidance of doubt, any reference to protection terms shall be
              interpreted in accordance with their meaning provided by GDPR.
            </li>
            <li>
              Customer acknowledges and agrees that when Sublyfe makes payments
              to or transacts with the Customer using a Third-Party Financial
              Company, personal data may be collected and disclosed. In such
              case, Sublyfe shall act as a data controller and the Third-Party
              Financial Company as a data processor. The information that the
              Third-Party Financial Company may collect includes payment method
              information (such as credit or debit card number, or bank account
              information), purchase amount, date of purchase, and in some
              cases, some information about the purchase. Different payment
              methods may require the collection of different categories of
              information. The payment method information that Third-Party
              Financial Company collects may depend upon the payment method
              chosen to use from the list of available payment methods that are
              offered at the time of check-out. Third-Party Financial Company
              may also receive the name, email, billing or shipping address and
              in some cases, the transaction history for authentication
              purposes. Third-Party Financial Company may also process IP
              addresses for fraud monitoring, prevention, detection, and
              compliance purposes.
            </li>
            <li>
              Customer has been informed about the fact that third parties from
              the EEU/EEA and outside of the EU/EEA may be able to take part of
              Customer’s information, data, personal data and/or material.
              Therefore, Customer hereby consents to any transfer of its
              information, data, personal data and/or material from Sublyfe to
              any third-party, however always subject to applicable law and
              regulations.
            </li>
          </ol>
        </li>
        <li>
          <strong>WARRANTIES</strong>
          <ol>
            <li>
              The Services are provided without warranty of merchantability or
              fitness for a particular purpose or any other warranty, expressed
              or implied. Sublyfe does not warrant or guarantee that the
              Services will be provided without interruptions, that any
              non-conformity arises, nor that the Services are free from defects
              and other errors. Sublyfe’s websites and applications are provided
              on an “as-is” basis and Sublyfe does not provide any express
              warranties including without limitation regarding the standard,
              delivery, timing, and security of the Services. Sublyfe shall take
              reasonable measures to ensure the availability of the Services.
              Sublyfe does however not guarantee any percentage rate of
              availability of a specific function, website or application
              included in the Services. Nor does Sublyfe guarantee the
              fulfillment of the product promised by its associated partners to
              be delivered to the customer at the suggested date of the
              customer`s subscription plan.
            </li>
            <li>
              Sublyfe reserves the right to modify, suspend, remove, and amend
              the Services, including the content of the Services, in its own
              discretion and without prior notice. Amendments that significantly
              alter Customer’s use of the Services will, however, be announced
              on Sublyfe’s website in due time prior to their entry into force.
              Sublyfe is not responsible for services, or any other activities
              provided by its associated partners. Sublyfe shall not be held
              responsible for any measures taken by its associated partners,
              including but not limited to changes in ownership, insolvency,
              delivery of the products, and/or litigation.
            </li>
            <li>
              Sublyfe may suspend the provision of the Services, for example in
              case of scheduled maintenance or in the event of a virus, worm,
              trojan or other attacks on Sublyfe’s IT environment. For the
              avoidance of doubt, Sublyfe does not seek to restrict any rights
              that consumers may have under applicable laws and regulations.
            </li>
            <li>
              In the event the data, information, content and/or products are
              claimed to be unlawful or illegal in any jurisdiction, Customer
              accepts full responsibility and shall reimburse any costs that
              Sublyfe may incur in relation to such claim. This includes but is
              not limited to any virus or other distracting program or device
              that could incur or injure any computer system.
            </li>
            <li>
              Parties accept that neither Customer nor Sublyfe shall have the
              right to base a claim on any written or oral warranties and
              representations not stated in these Terms of Use. Notwithstanding
              anything said in these Terms of Use so far, neither party excludes
              liability for gross negligence, wilful acts, fraudulent
              misrepresentation, or personal injury. Customer shall bear all
              costs relating to the use of the Services, including but not
              limited to contributions to the Internet Service Provider, however
              subject to applicable laws and regulations.
            </li>
            <li>
              The Services may be integrated with or provided in connection with
              third-party services (such as Stripe) or content. Sublyfe does not
              control these third-party services or their contents. Customer is
              advised to carefully review any agreements, terms and privacy
              policies relating to the services and/or their content of such
              third parties.
            </li>
          </ol>
        </li>
        <li>
          <strong>BREACH OF TERMS OF USE</strong>
          <ol>
            <li>
              Subject to applicable laws and regulations, Customer agrees to
              indemnify and hold Sublyfe and its affiliates and employees
              harmless against all liability, damages, claims, demands,
              reasonable legal costs and expenses of whatsoever nature arising
              out of or in connection with or as a consequence of Customer’s
              breach under these Terms of Use and in particular breach of any
              warranties and representations.
            </li>
            <li>
              If Customer violates a provision of these Terms of Use, Sublyfe
              shall, even without proof of intent or negligence, be entitled to
              damages for all loss caused to Sublyfe on account of the breach of
              the terms. In the event of Customer’s substantial breach of
              contract, Sublyfe shall also be entitled to terminate these Terms
              of Use with Customer with immediate effect and suspend Customer
              from further use of the Services. Customer shall not be entitled
              to any reimbursement of payments previously made to Sublyfe.
            </li>
            <li>
              NOTWITHSTANDING ANYTHING ELSE IN THESE TERMS OF USE, CUSTOMER
              SHALL NOT (AND SHALL NOT PERMIT ANY THIRD PARTY) TO USE THE
              SERVICES IN A MANNER THAT WOULD INFRINGE UPON THE INTELLECTUAL
              PROPERTY RIGHTS OF ANY THIRD PARTY, OR FOR ANY ILLEGAL TRANSACTION
              OR UNLAWFUL PURPOSE. Sublyfe SHALL NEVER BE LIABLE FOR THE PRODUCT
              THAT CUSTOMER MAY RECEIVE, OTHERWISE DISTRIBUTE BREACH OF TERMS OF
              USE.
            </li>
          </ol>
        </li>
        <li>
          <strong>LIABILITY</strong>
          <ol>
            <li>
              Any claim for compensation by Customer must be made at most two
              (2) months after the date when Customer first became aware of the
              breach. Notwithstanding anything said in this Agreement, Sublyfe
              does not seek to limit liability in respect of mandatory laws and
              regulations and in particular in respect of consumers.
            </li>
            <li>
              Sublyfe shall not be held liable for any delays and/or
              non-delivery of the Services under these Terms of Use.
            </li>
          </ol>
        </li>
        <li>
          <strong>CONFIDENTIALITY</strong>
          <ol>
            <li>
              Confidential information shall mean any information designated as
              confidential or which should otherwise reasonably be considered as
              being of a confidential nature, including but not limited to
              commercial, legal, financial, and business information as well as
              data, trade secrets, know-how, and any information on policies,
              services, processes, procedures, methods, formulations,
              intellectual property rights, facilities, products, plans,
              affairs, transactions, organizations, suppliers or business
              details, disclosed to the Receiving Party by or on behalf of the
              Disclosing Party in connection with this Agreement, whether or not
              such disclosure occurs before or after the execution of this
              Agreement, and regardless of the form in, or means by, which the
              Receiving Party received the information or the information was
              made available to such Party (“Confidential Information”).
            </li>
            <li>
              Confidential Information does not include information which the
              Receiving Party can demonstrate (i) is or becomes available to the
              public other than as a result of a breach of this Agreement or any
              confidentiality undertaking, (ii) was available to the Receiving
              Party on a non-confidential basis prior to its disclosure to the
              Receiving Party, (iii) becomes available to the Receiving Party on
              a non-confidential basis from a person, other than the Disclosing
              Party, who is not known by the Receiving Party to be bound by an
              obligation of confidentiality to the Disclosing Party or (iv) has
              been developed independently of the Disclosing Party’s
              Confidential Information.
            </li>
            <li>
              The Receiving Party agrees to (i) keep secret and not to disclose
              to any third party, directly or indirectly, any Confidential
              Information, (ii) to take all reasonable measures to ensure that
              Confidential Information is not disclosed and (iii) to only use
              the Confidential Information for the Purpose contemplated in this
              Agreement.
            </li>
            <li>
              The Receiving Party may disclose Confidential Information to its
              affiliates and its respective employees, directors, officers,
              consultants, advisors, accountants, subcontractors or
              sub-licensees (the “Affiliates”) who have a need to know such
              information for the Purpose. The Receiving Party shall however in
              such case impose on the Affiliates, in an appropriate manner, the
              obligations of confidentiality as set out herein. The Receiving
              Party shall be liable for any use and/or disclosure of
              Confidential Information by such Affiliates. The Receiving Party
              shall upon the Disclosing Party’s request inform the Disclosing
              Party of any external Affiliates to whom it has disclosed
              Confidential Information.{" "}
            </li>
            <li>
              Upon the Disclosing Party’s request, the Receiving Party and any
              of its Affiliates that have received Confidential information,
              shall keep a list of anyone who has been granted access to the
              Confidential Information. Such lists shall, upon the Disclosing
              Party’s request, be shared with the Disclosing Party.
            </li>
            <li>
              The obligation of confidentiality does not apply where the
              disclosure of Confidential Information is required by mandatory
              law, rule, regulation, applicable stock exchange rules or an order
              by court or authority, subject to what is set out in Section 1.7
              below.
            </li>
            <li>
              Should the Receiving Party be under obligation to disclose
              Confidential Information, in accordance with what is set forth in
              this Agreement, the Receiving Party shall without undue delay,
              where so is reasonably possible, before any disclosure is made,
              inform the Disclosing Party hereof in order for the Disclosing
              Party to be able to take such actions in order to protect the
              information as it may deem necessary. Any disclosure in accordance
              with this Agreement shall be made only to the extent so required.
              The Receiving Party furthermore undertakes to without delay inform
              the Disclosing Party in case it becomes aware of any unauthorized
              disclosure of Confidential Information and shall take all
              reasonable measures in order to prevent any further disclosure.
            </li>
            <li>
              The Receiving Party acknowledges that any Confidential Information
              is provided “as is” without any warranties as to its accuracy or
              completeness.
            </li>
          </ol>
        </li>
        <li>
          <strong>HANDLING OF CONFIDENTIAL INFORMATION</strong>
          <ol>
            <li>
              The Receiving Party undertakes to safeguard the other Party’s
              Confidential Information in a manner no less protective of such
              information than of its own information, and to keep the
              Confidential Information separate from its own information.
            </li>
            <li>
              Upon request by the Disclosing Party or upon termination of this
              Agreement, the Receiving Party undertakes to return and/or
              destroy, as requested, any material containing Confidential
              Information, as well as any copies of such information that the
              Receiving Party or its Affiliates have under their control. The
              Receiving Party undertakes to, upon request by the Disclosing
              Party, certify in writing that such return or destruction has
              occurred.
            </li>
            <li>
              Notwithstanding the foregoing, the Receiving Party shall be
              permitted to retain one copy of the Confidential Information as
              required by any law, regulation, court order or decision by court
              or regulatory authority. Confidential Information retained under
              this Section 2.3 shall remain subject to the confidentiality
              obligations set out in this Agreement.
            </li>
          </ol>
        </li>
        <li>
          <strong>OWNERSHIP</strong>
          <ol>
            <li>
              Ownership of any background, data, material, information,
              intellectual property, etc. provided by Sublyfe for the purposes
              of these Terms of Use, the Services, etc., shall continue to vest
              in Sublyfe. All rights are expressly reserved by Sublyfe, and
              Customer hereby explicitly consents that no right, title, or
              interest in or to the Services or anything contained therein is
              transferred to the Customer.
            </li>
            <li>
              Customer is granted a non-commercial, non-exclusive, limited,
              personal, non-transferable, non-sublicensable, revocable license
              to use the Services solely for its intended purpose. For the
              avoidance of doubt, Customer acknowledges that no vesting or
              licensing of Sublyfe’s raw data, personal data and/or material
              will take place under these Terms of Use.
            </li>
          </ol>
        </li>
        <li>
          <strong>DURATION AND TERMINATION</strong>
          <ol>
            <li>
              These Terms of Use shall enter into force on the date when
              Customer first uses the Services (i.e., registering for and/or
              using the Services in any manner, including but not limited to
              visiting or browsing Sublyfe’s website and/or sign up for an
              account via Sublyfe’s website).
            </li>
            <li>
              Each party shall have the right to cause these Terms of Use to be
              terminated at any time. Regardless, the subscription continues
              until the remaining balance of the subscription six (6) or twelve
              (12) months has been paid in full.
            </li>
            <li>
              All Paid Subscriptions renew automatically, unless terminated or
              modified under these Terms of Use. If you have a yearly Paid
              Subscription, Digito will contact you at least 15 days prior to
              the end of the term of your Paid Subscription via email to remind
              you that the term of your Paid Subscription will automatically
              renew.
            </li>
            <li>
              Digito may terminate your account and access to the Services and
              other rights to access the website and/or application immediately
              if (a) you breach these Terms of Use or Digito is required to
              terminate such rights by law due to misconduct, or (b) for
              convenience with five (5) days’ notice; provided, however, that if
              you have a Paid Subscription, any notice of termination for
              convenience will not be effective until the end of your
              then-current Paid Subscription term. These remedies are in
              addition to any other remedies Digito may have at law.
            </li>
            <li>
              The Customer may cancel or elect to not renew the Paid
              Subscription at any time by contacting Digito at info@sublyfe.com.
              If, after terminating your Paid Subscription or, if you do not
              have a Paid Subscription, at any time, you wish to terminate your
              account, you can do so by stopping your use of the Services.
            </li>
            <li>
              If the Customer terminates its Paid Subscription or its account,
              the Customer’s ability to access the Services ends immediately.
              The Customer is not entitled to any refund or other compensation
              for the termination of your account or Paid Subscription in
              accordance with its terms. These Terms of Use shall not otherwise
              be affected and will survive the termination of your account or
              Paid Subscription for any reason.
            </li>
            <li>
              Notwithstanding the provisions above, these Terms of Use may be
              terminated: by either party with immediate effect upon written
              notice if the other party should become insolvent or a petition in
              bankruptcy should be filed by or against it, or a receiver of its
              property or a substantial part thereof should be appointed.
            </li>
            <li>
              For consumers, a Withdrawal period of fourteen (14) days applies
              in accordance with these Terms of Use.
            </li>
          </ol>
        </li>
        <li>
          <strong>MISCELLANEOUS</strong>
          <ol>
            <li>
              Any notice to be given by either party pursuant to these Terms of
              Use must be in writing and may be sent by email to the e-mail
              address of the recipient party.
            </li>
            <li>
              These Terms of Use are in the English language only. Any versions
              of these Terms of Use in any other language will be for
              accommodation only and will not be binding on either party.
            </li>
            <li>
              The parties understand and agree that their relationship hereunder
              is one of contract and that they are not and shall not be
              construed as partners, joint ventures, or agent and principal. In
              no event shall either party be authorized to act for or on behalf
              of the other party.
            </li>
            <li>
              If any provision of these Terms of Use is held by a court of
              competent jurisdiction to be invalid under any applicable statute,
              rule or law, each party agrees that such invalidity shall not
              affect the validity of the remaining provisions of these Terms of
              Use, and further agree to substitute for the invalid provision a
              valid provision which most closely approximates the intent and
              economic effect of the invalid provision.
            </li>
            <li>
              Sublyfe shall have the right to co-operate and/or enter into
              agreement with any other third-party including other customers and
              Sublyfe shall have no restriction on competition.
            </li>
            <li>
              Sublyfe shall have the right to assign all or part of these Terms
              of Use without Customer’s approval. Neither these Terms of Use nor
              any rights under these Terms of Use shall be assigned or otherwise
              transferred by Customer without the prior written consent of
              Sublyfe. No one other than each party under these Terms of Use has
              any right to enforce any term herein. These Terms of Use shall
              bind and insure to the benefit of the successors and permitted
              assigns of the parties.
            </li>
            <li>
              Sublyfe retains the right to update, amend or otherwise modify
              these Terms of Use at its own absolute discretion. You will be
              notified of updates, amendments, and modifications in due time
              prior to their entry into force and they will take effect on the
              date stated in the notification to you. Your use of the Services
              also constitutes an acceptance of these Terms of Use; hence your
              continued use of the Services shall be regulated by any updated
              Terms of Use from the date of their entry into force.
            </li>
            <li>
              These Terms of Use constitutes the entire agreement between
              Customer and Sublyfe with respect to this subject matter, and
              supersedes all prior and contemporaneous discussions,
              communications and agreements, written or oral, with respect
              thereto. Customer and Sublyfe confirm that they have not been
              induced to enter into these Terms of Use as a result of any
              representation or statement which is not set out herein.
            </li>
            <li>
              These Terms of Use may be amended from time to time. Supplemental
              terms and conditions or documents are hereby expressly
              incorporated herein by reference. You waive any right to receive
              specific notice of each such amendment.
            </li>
          </ol>
        </li>
        <li>
          <strong>LAW AND JURISDICTION</strong>
          <ol>
            <li>
              If Customer files a complaint, such complaint may be sent to
              Digito by mail; Digito Group AB Skånegatan, 83, 11635 Stockholm,
              or by e-mail; info@sublyfe.com
            </li>
            <li>
              In the event Customer is a consumer, the Customer may also have
              the right to report or file a complaint to the general complaints
              board in its country. The Swedish general complaints board is
              National Board for Consumer Disputes (ARN): www.arn.se. Customer
              may also report or file a complaint through the European
              Commission’s Online Dispute Resolution:
              www.ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=SV.
            </li>
            <li>
              Customer endeavors to use its reasonable efforts to negotiate and
              settle any dispute or claim that may arise in relation to these
              Terms of Use.
            </li>
            <li>
              These Terms of Use and all matters in relation to the Services
              shall be construed in accordance with Swedish law and the Swedish
              courts shall have jurisdiction, however always subject to
              mandatory consumer law.
            </li>
          </ol>
        </li>
      </ol>
    </Wrapper>
  );
};

export default Terms;
